export default function HeroMock() {
  return (
    <div className="relative" data-testid="hero-mock">
      <div className="absolute -inset-4 bg-gradient-to-br from-emerald-500/10 via-transparent to-red-500/10 blur-2xl" />
      <div className="relative border border-white/10 bg-[#0C0E13] p-5">
        <div className="flex items-center justify-between">
          <div className="kicker">Illustrative preview · Not a real site</div>
          <div className="text-[10px] font-mono-alt tracking-[0.14em] text-white/40">PRI · 2026</div>
        </div>
        <div className="mt-4 border border-white/10 aspect-[16/10] relative overflow-hidden bg-[#0A0B0E]">
          <svg viewBox="0 0 400 250" className="absolute inset-0 w-full h-full">
            <defs>
              <pattern id="grid" width="20" height="20" patternUnits="userSpaceOnUse">
                <path d="M20 0H0V20" fill="none" stroke="rgba(255,255,255,0.06)" />
              </pattern>
              <radialGradient id="rGrad" cx="22%" cy="30%">
                <stop offset="0%" stopColor="#ef4444" stopOpacity="0.55" />
                <stop offset="100%" stopColor="#ef4444" stopOpacity="0" />
              </radialGradient>
              <radialGradient id="aGrad" cx="70%" cy="35%">
                <stop offset="0%" stopColor="#f59e0b" stopOpacity="0.4" />
                <stop offset="100%" stopColor="#f59e0b" stopOpacity="0" />
              </radialGradient>
            </defs>
            <rect width="400" height="250" fill="url(#grid)" />
            <rect width="400" height="250" fill="url(#rGrad)" />
            <rect width="400" height="250" fill="url(#aGrad)" />
            {/* Watercourse pathway */}
            <path d="M60,60 C120,90 150,140 210,150 S300,170 380,230" fill="none" stroke="#38bdf8" strokeOpacity="0.5" strokeWidth="2" strokeDasharray="2 3" />
            {/* Site boundary */}
            <polygon points="150,110 270,100 290,175 220,205 135,185"
              fill="rgba(16,185,129,0.08)" stroke="#10b981" strokeDasharray="4 4" strokeWidth="1.5" />
            <circle cx="85" cy="70" r="6" fill="#ef4444" />
            <circle cx="255" cy="105" r="6" fill="#f59e0b" />
            <circle cx="215" cy="165" r="6" fill="#10b981" />
          </svg>
        </div>
        <div className="mt-4 grid grid-cols-3 gap-2 text-[11px]">
          <RagRow tone="red" label="Off-site fire-training area · potential AFFF source" value="RED" />
          <RagRow tone="amber" label="Surface-water pathway towards site" value="AMBER" />
          <RagRow tone="emerald" label="Generic on-site industrial history · no PFAS-specific evidence" value="GREEN" />
        </div>
        <div className="mt-4 border-t border-white/10 pt-3 flex items-center justify-between gap-4">
          <div className="kicker">Recommended</div>
          <div className="text-sm text-white text-right">Targeted PFAS review before commitment</div>
        </div>
      </div>
    </div>
  );
}

function RagRow({ tone, label, value }) {
  const bg = { red: "bg-red-500/10 border-red-500/30 text-red-400",
               amber: "bg-amber-500/10 border-amber-500/30 text-amber-400",
               emerald: "bg-emerald-500/10 border-emerald-500/30 text-emerald-400" }[tone];
  return (
    <div className={`border ${bg} px-2 py-2`}>
      <div className="text-[9px] font-mono-alt tracking-[0.14em] opacity-80">{value}</div>
      <div className="mt-1 text-white/80 text-[11px] leading-tight">{label}</div>
    </div>
  );
}
